import type { Nullish } from '@logistiek-zonder-papier/lzp-library'
import { type UUID } from 'node:crypto'

export type SubApp = {
  id: UUID | Nullish
  customerId: string | null
  name: string
  cluster: string
  intent: string | null
  imageId: string
  imageSrc: string
  translationsFileId: UUID | null
  visible: boolean
  homeConfig: string[]
  menuConfig: string[]
  cssVariables: Record<string, string>
  legacyId: string | null
  legacyRegistrationEndpoint: string | null
}

export const SubAppColourVariables: { label: string; css: string }[] = [
  { label: 'Primary Button', css: '--colours-primary' },
  { label: 'Secondary Button', css: '--colours-secondary' },
  { label: 'Text Primary', css: '--colours-primary-text' },
  { label: 'Text Secondary', css: '--colours-secondary-text' },
  { label: 'App Bar', css: '--colours-app-bar' },
  { label: 'App Bar Text', css: '--colours-app-bar-text' },
  { label: 'Menu Bar', css: '--colours-menu-bar' },
  { label: 'Menu Bar Text', css: '--colours-menu-bar-text' },
  { label: 'Status Bar', css: '--colours-status-bar' },
]

export type SubAppPayload = SubApp & {
  image: File | undefined
}

export type SubAppErrors = {
  name?: string
  customerId?: string
  cluster?: string
  image?: string
  legacyId?: string
  legacyRegistrationEndpoint?: string
}

export type UploadResponse = {
  id: string
  message: string
  location: string
  originalName: string
}

export function createEmptySubAppPayload(): SubAppPayload {
  return {
    id: undefined,
    name: '',
    customerId: '',
    cluster: '',
    visible: false,
    intent: null,
    imageId: '',
    image: undefined,
    imageSrc: '',
    translationsFileId: null,
    homeConfig: [],
    menuConfig: [],
    cssVariables: {
      '--colours-primary': '#ffffff',
      '--colours-primary-text': '#000000',
      '--colours-secondary': '#ffffff',
      '--colours-secondary-text': '#000000',
      '--colours-app-bar': '#0074c2',
    },
    legacyId: null,
    legacyRegistrationEndpoint: null,
  }
}

export function createEmptySubApp(): SubApp {
  return {
    id: undefined,
    name: '',
    customerId: '',
    cluster: '',
    visible: false,
    intent: null,
    imageId: '',
    imageSrc: '',
    translationsFileId: null,
    homeConfig: [],
    menuConfig: [],
    cssVariables: {},
    legacyId: null,
    legacyRegistrationEndpoint: null,
  }
}

export function subAppToPayload(subApp: SubApp, imageBlob?: Blob): SubAppPayload {
  return {
    ...subApp,
    image: imageBlob
      ? new File([imageBlob], `${subApp.name}-image`, { type: imageBlob.type })
      : undefined,
  }
}
